import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  z-index: 1;
`

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  min-height: 40px;
`

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-50);
`

export const HeaderLabelWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-200);
`

export const DropdownButton = styled.div`
  cursor: pointer;
`

export const HeaderLabel = styled.div<{ underline?: boolean; isDropdownTrigger?: boolean }>`
  font-size: var(--font-size-400);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-400); /* 150% */
  letter-spacing: var(--font-letter-spacing-normal);
  user-select: none;

  a {
    text-decoration: none;
  }

  ${({ underline }) =>
    underline &&
    css`
      cursor: default;
      text-decoration-line: underline;
      text-decoration-style: dotted;
      text-decoration-skip-ink: none;
      text-decoration-color: var(--text-secondary-invert);
      text-decoration-thickness: 16%; /* 2.56px */
      text-underline-offset: 25%; /* 4px */
      z-index: 1;

      &:hover {
        text-decoration-color: var(--text-primary);
      }
    `}

  ${({ isDropdownTrigger }) =>
    isDropdownTrigger &&
    css`
      cursor: pointer;
    `}
`

export const DropdownContent = styled.div`
  display: flex;
  gap: var(--space-100);
  align-items: center;
  cursor: pointer;
`

export const Subtitle = styled.div`
  color: var(--text-secondary);
  font-family: var(--font-family-body);
  font-size: var(--font-size-300);
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-300); /* 142.857% */
  letter-spacing: var(--font-letter-spacing-loose);
`

export const ValueContainer = styled.div`
  display: flex;
  gap: var(--space-300);
  align-items: center;
`

export const Value = styled.div`
  display: flex;
  font-family: var(--font-family-heading);
  font-size: var(--font-size-700);
  font-weight: var(--font-weight-semibold);
  line-height: var(--font-line-height-600); /* 112.5% */
  letter-spacing: var(--font-letter-spacing-densest);
  min-height: 16px;
`
